import { Wrapper } from "../components/layout/wrapper";
import { gql } from "@apollo/client";
import { useLocaleContext } from "@ct-react/locale";
import { CmsPageContent, extractCmsContent } from "@shared/graphql";
import { classNames, useAppConfig } from "@ct-react/core";
import { useMemo } from "react";
import { useLocation } from "react-router";
import { useQuery } from "@apollo/client/react";
import EditorialSeo from "../components/layout/editorial-seo";
import RatioImage from "../components/medias/ratio-image";
import Banner from "../components/layout/wrapper/banner";
import Skeleton from "react-loading-skeleton";
import { getPageDataByPath } from "@shared/cms";
import { useScrollAnimations } from "../hooks/scroll-animations";
import NotFoundPage from "./not-found";

const CMS_PAGE_GQL_DATA = gql`
  query RenovationPageCmsPage($templateId: UUID!) {
    cmsPages(templateId: $templateId) { data }
  }
`;

const Renovation = () => {
  const { locale } = useLocaleContext();
  const { pathname } = useLocation();

  const { options: { cmsTemplates: { editorial: templateId } } } = useAppConfig();

  const { data, loading } = useQuery<{ cmsPages: any }>(CMS_PAGE_GQL_DATA, {
    ssr: true,
    variables: { templateId }
  });

  const cmsContent = useMemo<CmsPageContent | undefined>(() => {
    if (!data?.cmsPages?.length) return undefined;
    const page = getPageDataByPath(data.cmsPages, pathname);
    return page ? extractCmsContent(page, locale) : undefined;
  }, [ data, pathname, locale ]);

  useScrollAnimations([loading, cmsContent]);

  if (!loading && Array.isArray(data?.cmsPages) && !cmsContent) return <NotFoundPage />;

  const seo = cmsContent?.["seo-data"];

  return(
    <>

      <EditorialSeo page="renovation" seo={seo} />

      <Banner loading={loading} data={cmsContent} />

      {cmsContent?.["section-items"]?.map((section:any, index:number) => (
        <Wrapper.TwoCol as="section"
                        className={classNames("animate animate-image animate-text",{ "reverse" : index % 2 === 0})}
                        title={!loading ? section["section-title"] : undefined}
                        key={index}>
          <Wrapper.ColText>
            {loading ? <p><Skeleton count={10} /></p> : <div className="desc" dangerouslySetInnerHTML={{ __html: section["section-body"] }} />}
          </Wrapper.ColText>
          <Wrapper.ColImage>
            {loading
              ? <picture className="rimg skeleton"><Skeleton height="100%"/></picture>
              : <RatioImage source={section["section-image"].assets}
                            alt={section["section-image"].alternativeText || section["section-title"]} />}
          </Wrapper.ColImage>
        </Wrapper.TwoCol>
      ))}
    </>
  );
};

export default Renovation;
